module.exports = __webpack_public_path__ + "static/media/about-bg.15728850.png";